import { RootState } from "common/reducers";

const rootKey = "users";

/**
 * Loads the user from byID
 *
 * @param {RootState} state The RootState
 * @param {{userId: number}} options
 * @returns {UserRecord} UserRecord
 */
export const user = (state: RootState, props: any) => state.getIn([rootKey, "byId"]).get(props.userId);

/**
 * Loads the current user using currentUser
 *
 * @param {RootState} state The RootState
 * @param {{}} options
 * @returns {UserRecord} UserRecord
 */
export const currentUser = (state: RootState) => state.getIn([rootKey, "currentUser"]);
